var map = {
	"./adult/nn/wordchain-data.json": 608,
	"./adult/no/wordchain-data.json": 609,
	"./youth/de/wordchain-data.json": 610,
	"./youth/nn/wordchain-data.json": 611,
	"./youth/no/wordchain-data.json": 612,
	"./youth/se/wordchain-data.json": 613
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 607;